import React, {PureComponent} from "react"

import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"
import {Body, H3, H4, Label} from "@irati/ui/src/Typography"
import {ReactTable} from "@irati/ui/src/Table"
import Link from "@irati/ui/src/Link"
import buService from "@irati/billing/services/bu"
import authentication from "@irati/auth"
import Loading from "@irati/ui/src/Loading"
import Flex from "@irati/ui/src/Flex"
import {Invoice} from "@irati/types"

import Expander from "@irati/ui/src/Expander"
import makePDF from "@irati/utils/pdf/makePDF"
import {EmptyData} from "../../Reporting/EmptyData"
import SliderInfo from "../../Dashboard/Integrations/SliderInfo"
import columns from "./columns"

const INITIAL_INVOICES_DISPLAYED_NUM = 5

interface Props extends InjectIntl {}

interface State {
  invoices: Invoice[]
  load: Promise<void> | null
  downloadLoad: Promise<void> | null
  invoiceId: string
  showAll: boolean
}

class Invoices extends PureComponent<Props, State> {
  state = {
    invoices: [],
    load: null,
    downloadLoad: null,
    showAll: false
  }

  componentDidMount() {
    const load = buService.getInvoices({businessId: authentication.business().uuid}).then(({invoices}: {invoices: Invoice[]}) => {
      this.setState({invoices})
    })
    this.setState({load})
  }

  toggleShowAll = () => {
    this.setState((prevState: State) => ({
      showAll: !prevState.showAll
    }))
  }

  handleInvoiceDownload = (invoiceId: string) => {
    const downloadLoad = buService.getInvoiceBody({invoiceId}).then((res) => {
      makePDF(res?.body, "invoices.pdf")
    })
    this.setState({downloadLoad, invoiceId})
  }

  render() {
    const {formatMessage} = this.props
    const {invoices, load, showAll, downloadLoad, invoiceId} = this.state
    const invoicesToRender =
      showAll || invoices.length < INITIAL_INVOICES_DISPLAYED_NUM ? invoices : invoices.slice(0, INITIAL_INVOICES_DISPLAYED_NUM)

    return (
      <>
        <H3 marginBottom={3}>
          <FormattedMessage id="admin.billing.title" />
        </H3>
        <Loading load={load}>
          {invoicesToRender?.length ? (
            <>
              <ReactTable
                manual={false}
                showPagination={false}
                data={invoicesToRender}
                columns={columns(formatMessage, this.handleInvoiceDownload, downloadLoad, invoiceId)}
              />
              <Flex justifyContent="center">
                <Expander
                  onChange={this.toggleShowAll}
                  hideText={formatMessage({id: "admin.reporting.popularPerks.buttons.seeLess"})}
                  showText={formatMessage({id: "admin.reporting.popularPerks.buttons.seeAll"})}
                  HeaderLabel={Label}
                />
              </Flex>
              <SliderInfo>
                <>
                  <H4 marginBottom={2}>
                    <FormattedMessage id="admin.billing.faqs.title" />
                  </H4>
                  <Body>
                    <FormattedMessage
                      id="admin.billing.faqs.help.body"
                      values={{
                        link: (
                          <Link href={formatMessage({id: "admin.billing.faqs.link.url"})} target="_blank">
                            <FormattedMessage id="admin.billing.faqs.link.text" />
                          </Link>
                        )
                      }}
                    />
                  </Body>
                </>
                <>
                  <H4 marginBottom={2}>
                    <FormattedMessage id="admin.billing.faqs.help.title" />
                  </H4>
                  <Body>
                    <FormattedMessage
                      id="admin.billing.faqs.link.body"
                      values={{
                        link: (
                          <Link href={formatMessage({id: "admin.billing.faqs.help.url"})} target="_blank">
                            <FormattedMessage id="admin.billing.faqs.help.text" />
                          </Link>
                        )
                      }}
                    />
                  </Body>
                </>
              </SliderInfo>
            </>
          ) : (
            <EmptyData text="admin.billing.empty" />
          )}
        </Loading>
      </>
    )
  }
}

export default injectIntl(Invoices)
